import { render, staticRenderFns } from "./ApprovalStatus.vue?vue&type=template&id=3470cf0c"
import script from "./ApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ApprovalStatus.vue?vue&type=script&lang=js"
import style0 from "./ApprovalStatus.vue?vue&type=style&index=0&id=3470cf0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports